import { RDStationMarketingPluginSettingsData } from "@/protocols/RdStationPluginProtocol"

import ApiService from "@/services/Api"

export type RDStationMarketingCheckAuthCredentialsResponse = {
	dataValues: RDStationMarketingPluginSettingsData
}

export type RDStationMarketingEncryptStateDataResponse = {
	RdStationMarketingStateToken: string
}

type CheckAuthCredentialsResponse = {
	dataValues: RDStationMarketingPluginSettingsData
}

class RDStationMarketingService {
	async checkAuthCredentials (): Promise<RDStationMarketingPluginSettingsData> {
		const response = await ApiService.get<CheckAuthCredentialsResponse>("/plugin-settings/rd-station-marketing/check-auth-credentials")

		return response.data.dataValues
	}

	async getEncryptStateData (): Promise<RDStationMarketingEncryptStateDataResponse> {
		const response = await ApiService.get("/plugin-settings/rd-station-marketing/encrypt-state-data")

		return response.data
	}

	async revoke (pluginId: number): Promise<void> {
		await ApiService.post("/plugin-settings/rd-station-marketing/revoke", { pluginId })
	}
}

export default new RDStationMarketingService()
